import { render, staticRenderFns } from "./ngo-registered-ngos.vue?vue&type=template&id=1eef455f&scoped=true&"
import script from "./ngo-registered-ngos.vue?vue&type=script&lang=js&"
export * from "./ngo-registered-ngos.vue?vue&type=script&lang=js&"
import style0 from "./ngo-registered-ngos.vue?vue&type=style&index=0&id=1eef455f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eef455f",
  null
  
)

export default component.exports